export enum FlightSchoolStatus {
    Active = 'Active',
    NotVisible = 'Not Visible',
    Archived = 'Archived',
}
